import { Spinner } from "flowbite-react";
import React from "react";

const LoadingIcon = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center gap-2 h-fit">
        <div className="text-center">
          <Spinner aria-label="Center-aligned spinner example" size="xl" />
        </div>
      </div>
    </>
  );
};

export default LoadingIcon;
